(function () {
  angular.module("akitabox.ui.dialogs.updateIdentityNames", [
    "akitabox.core.constants",
    "akitabox.core.services.env",
    "akitabox.core.services.flag",
    "akitabox.core.services.identity",
  ]);
})();
